import {
    MOBILE_CHAT
} from './constants';

// eslint-disable-next-line import/prefer-default-export
export function toggleMobileChat() {
    return { type: MOBILE_CHAT };
}
